/* Made Design — studio cursor: dot follows the pointer, ring trails it */
(function(){
  if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root=document.documentElement;
  var dot=document.createElement('div'),ring=document.createElement('div'),label=document.createElement('span');
  dot.className='md-cursor';ring.className='md-cursor-ring';ring.appendChild(label);
  dot.setAttribute('aria-hidden','true');ring.setAttribute('aria-hidden','true');
  document.body.appendChild(ring);document.body.appendChild(dot);
  root.classList.add('has-cursor');
  var mx=-100,my=-100,rx=-100,ry=-100,raf=null;
  function loop(){
    var k=reduce?1:.16;
    rx+=(mx-rx)*k;ry+=(my-ry)*k;
    ring.style.transform='translate3d('+rx+'px,'+ry+'px,0)';
    if(Math.abs(mx-rx)>.1||Math.abs(my-ry)>.1){raf=requestAnimationFrame(loop)}else{raf=null}
  }
  document.addEventListener('mousemove',function(e){
    mx=e.clientX;my=e.clientY;
    dot.style.transform='translate3d('+mx+'px,'+my+'px,0)';
    if(!root.classList.contains('cursor-on')){root.classList.add('cursor-on');rx=mx;ry=my}
    if(!raf) raf=requestAnimationFrame(loop);
  },{passive:true});
  document.addEventListener('mouseleave',function(){root.classList.remove('cursor-on')});
  document.addEventListener('mouseenter',function(){root.classList.add('cursor-on')});
  document.addEventListener('mousedown',function(){root.classList.add('cursor-down')});
  document.addEventListener('mouseup',function(){root.classList.remove('cursor-down')});
  var VIEW='[data-cursor="view"],.product-card,.hs-spec:not(.hs-spec--end),.hs-arch__item,.product-card__media,.pdp-media img,.pdp-gallery img';
  var LINK='a,button,[role="button"],summary,label,select,.hs-index__row';
  var TEXT='input,textarea,[contenteditable]';
  document.addEventListener('mouseover',function(e){
    var t=e.target;
    root.classList.remove('cursor-view','cursor-link','cursor-text');
    if(t.closest(TEXT)){root.classList.add('cursor-text');return}
    var v=t.closest(VIEW);
    if(v){label.textContent=v.getAttribute('data-cursor-label')||'View';root.classList.add('cursor-view');return}
    if(t.closest(LINK)) root.classList.add('cursor-link');
  },{passive:true});
})();
